import { authAPI } from './api';

/**
 * Marks a specific onboarding step as complete in the backend.
 * This is used for "Action-to-Onboarding" synchronization.
 * 
 * @param {string} stepId - The ID of the step (e.g., 'msp_account', 'add_tenant')
 */
export const markOnboardingStepComplete = async (stepId) => {
  try {
    // 1. Get current state
    const response = await authAPI.getOnboardingState();
    const currentState = response.data || {};
    
    // 2. If already complete, skip
    if (currentState[stepId]) return;

    // 3. Update state
    const newState = {
      ...currentState,
      [stepId]: true
    };
    
    await authAPI.updateOnboardingState(newState);
    console.log(`Onboarding step "${stepId}" automatically marked as complete.`);
  } catch (err) {
    // Silently fail as this is a background enhancement
    console.error(`Failed to auto-sync onboarding step ${stepId}:`, err);
  }
};
